/* eslint eqeqeq: 'off' */
import React, { Component } from 'react';
import { connect } from "react-redux";
import { Table, Button, Modal } from 'reactstrap';
import classnames from 'classnames';
import * as ErrorMessage from '../../../../../Resources/ErrorMessages';
import ErrorGif from '../../../../../Assets/images/Error.gif';
import '../../../../../Assets/EnsembleStyles/Administration/buildinginstallation.css';
import { GetBuildingsDiscovered,DeleteInstalledBuildings,SynchronizedDatabase } from '../../../../../action/Administration/administrationAction';
import DeleteConfirmation from '../../../TenantComponents/ManageTenants/_ModalsForms/DeleteConfirmation';
import SelectAllCheckboxes from '../../../../../Resources/SelectAllCheckboxes';
import SearchInput, { createFilter } from 'react-search-input';
import { getAllResources } from '../../../../../action/cultureAction';
const KEYS_TO_FILTERS = ['siteName', 'requestStatus'];


class InstalledBuildings extends Component {
    componentWillMount(){
        if(this.props.getLabels["ActionsAndSettings.UAText.Text"] === undefined){
            this.props.getAllResources();
        }
    }
    componentWillUnmount(){
        clearInterval(this.intervalId);
    }
    componentDidMount() {
        const actionResponse = this.props.GetBuildingsDiscovered();
        actionResponse.then((result)=>{
        var data = this.state.Discovered_buildings_list_state;
        if (data != undefined && data != null && data.length > 0 ) {
                var details = data.filter(function (item) {
                    return item.isSynchronizing === true
                });
                if(details !== undefined && details !== null && details.length){
                    this.intervalId  = setInterval(() => {
                        this.props.GetBuildingsDiscovered();
                    }, 10000);
                }else{
                    clearInterval(this.intervalId);
                }
            }
        });
    }

    componentWillReceiveProps(nextProps) {
        if (this.props != nextProps) {
            this.setState({ Discovered_buildings_list_state: nextProps.Discovered_buildings_list_response });
        }
    }

    constructor(props) {
        super(props)
        this.state = {
            loading: true,
            error_msg: false,
            error_msg1: false,
            Deletemodal: false,
            showmodal: false,
            searchTermVal: '',
            message:'',
            Discovered_buildings_list_state: null,
            sort: {
                column: null,
                direction: 'asc',
            },
        }
        this.searchUpdated = this.searchUpdated.bind(this);
        this.delete_Failed_Installations = this.delete_Failed_Installations.bind(this);
        this.SynchronizedDatabase = this.SynchronizedDatabase.bind(this);
        this.hidemodal = this.hidemodal.bind(this);
    }

    /* Filter System */
    searchUpdated(term) {
        this.setState({ searchTermVal: term })
    }



  /* Delete Confirmation*/



  Deletetoggle() {
    this.setState({
        Deletemodal: !this.state.Deletemodal
    });
  }


  delete_Failed_Installations() {
    this.setState({ error_msg: false });
    var IsAnyChecked = false;
    var checkboxes = document.getElementsByClassName('Installed_buildings_checkboxes');
    for (var i = 0; i < checkboxes.length; i++) {
        if (checkboxes[i].checked === true) {
            IsAnyChecked = true;
        }
    }
    if (IsAnyChecked) this.Deletetoggle();
    else this.setState({ error_msg: true });
}



  Delete = (someArg) => {
    if (someArg == "yes") {
        var Data = [];
        var checkboxes = document.getElementsByClassName('Installed_buildings_checkboxes');
        for (var i = 0; i < checkboxes.length; i++) {
            if (checkboxes[i].checked === true) {
                var discovery_id_to_be_deleted = {
                    "buildingId": checkboxes[i].id
                }
                Data.push(discovery_id_to_be_deleted);
            }
        }
        if (Data.length > 0) {
            this.setState({ error_msg: false });
           this.props.DeleteInstalledBuildings(Data);
            this.Deletetoggle();
        }
        else {
            this.setState({ error_msg: true });
            this.Deletetoggle();
        }
    }
    else {
        this.Deletetoggle();
    }
}

//Synchronized database
SynchronizedDatabase(){
    this.setState({ error_msg: false });
    var BuildingData = [];
    var checkboxes = document.getElementsByClassName('Installed_buildings_checkboxes');
    for (var i = 0; i < checkboxes.length; i++) {
        if (checkboxes[i].checked === true) {
            var Building_id = {
                "buildingId": checkboxes[i].id
            }
            BuildingData.push(Building_id);
        }
    }
    if (BuildingData.length > 0) {
        this.setState({ error_msg: false });
        const actionResponse = this.props.SynchronizedDatabase(BuildingData);
        actionResponse.then((result)=>{
            if(this.props.getResponse.status !== undefined && this.props.getResponse.status === 200){
                var checkboxes = document.getElementsByClassName("Installed_buildings_checkboxes");
                for (var i = 0; i < checkboxes.length; i++) {
                    checkboxes[i].checked = false;
                }
                this.setState({showmodal:true,message:"The synchronization operation for selected building(s) triggered successfully!"});
            }
            else
                this.setState({showmodal:true,message:"The synchronization operation for selected building(s) failed!"});
                
            const actionResponse = this.props.GetBuildingsDiscovered();
            actionResponse.then((result) => {
                var data = this.state.Discovered_buildings_list_state;
                if (data != undefined && data != null && data.length > 0) {
                    var details = data.filter(function (item) {
                        return item.isSynchronizing === true
                    });
                    if (details !== undefined && details !== null && details.length) {
                        this.intervalId = setInterval(() => {
                            this.props.GetBuildingsDiscovered();
                        }, 10000);
                    } else {
                        clearInterval(this.intervalId);
                    }
                }
            });
        })
    }
    else {
         this.setState({ error_msg: true });
    }
}

//hide modal
hidemodal (){
    this.setState({
        showmodal:false
    });
}
/* Sorting  System */

onSort = (column) => (e) => {
    const direction = this.state.sort.column ? (this.state.sort.direction === 'asc' ? 'desc' : 'asc') : 'desc';
    var data_from_state = this.state.Discovered_buildings_list_state;
    if(data_from_state != null){
    const sortedData = this.state.Discovered_buildings_list_state.sort((a, b) => {
        if (typeof  a[column] === 'string' && typeof  b[column] === 'string'){
            const nameA = a[column].toLowerCase();
            const nameB = b[column].toLowerCase();

        if (nameA < nameB) {
            return -1;
        }
        if (nameA > nameB) {
            return 1;
        }
         return 0;
        }
        else{   //Checking for integers / numbers
            
            const nameA = a[column];
            const nameB = b[column];

        if (nameA < nameB) {
            return -1;
        }
        if (nameA > nameB) {
            return 1;
        }
         return 0;
        }

           
    });


    if(this.state.sort.direction =='desc'){
          sortedData.reverse();
       
     }
   
    this.setState({
        Discovered_buildings_list_state: sortedData,
        sort: {
            column,
            direction,
        }
    });
}
};


setArrow = (column) => {
    let className = 'sort-direction';
    if (this.state.sort.column === column) {
        className += this.state.sort.direction === 'asc' ? ' asc' : ' desc';
    }
    return className;
};



    render(getLabels) {

        let data, filteredData, BuildingsList,CountList,Error_Message = null;
        let label = this.props.getLabels;

        data = this.state.Discovered_buildings_list_state;
        if (data != undefined && data.length > 0 && data != null) {
            var details = data.filter(function (item) {
                return item.isSynchronizing === true
            });
            if (details === undefined || details === null || !details.length) {
                clearInterval(this.intervalId);
            }
            
            filteredData = data.filter(createFilter(this.state.searchTermVal, KEYS_TO_FILTERS));
            if (filteredData.length != 0) {
                BuildingsList = filteredData.map(el => (
                    <tr key={el.discoveryRequestId}>
                
                        <th className="check_box_column_width"><input type="checkbox" id={el.siteId} className="Installed_buildings_checkboxes" onClick={() => { SelectAllCheckboxes.ResetHeaderCheckBox("Installed_buildings_checkboxes", "installed_heading_Check_box"); }} value={el.siteId} /></th>
                        <td><label style={{ color: '#6890C6' }}  className="link_cursor">{el.siteName}</label></td>
                        <td>
                            {el.isSynchronizing === true ? label['SiteSync.Status.Synchronizing.Text'] : label['InstallBuilding.Status.'+el.requestStatusText+'.Text']}
                        </td>
                        <td>{el.numberOfPanelsLoaded}{" of "}{el.numberOfPanelsDiscovered}{" Devices Loaded"} </td>
                    </tr>
                ));
                CountList = <p className="count">Items 1 to {filteredData.length} of {filteredData.length}   </p>
            }
            else {
                BuildingsList = <tr><td  colSpan="6">{"No Records Found."}</td></tr>
            }
        }
        else {
            BuildingsList = <tr><td  colSpan="6">{"No Records Found."}</td></tr>
        }

        // Error Message
        (this.state.error_msg == true) ? Error_Message = <p className="error_msg"> <img src={ErrorGif} alt="Trane Logo" />  {ErrorMessage.selection_error}</p> : Error_Message = " ";
       
        //Rendering
        return (

            <div className="discovery_content2 sub_text">
             
              <div className="tableandbtns_content2">
              <div className="table_div">
              <p className="bold_sub_text installed_subtext">Installed Buildings</p>
              <SearchInput className="search-input installed_search" onChange={this.searchUpdated} />
              { Error_Message}
                <div className="table_container">
                        <Table striped responsive className="Custom_table">
                            <tbody>
                                <tr>
                                
                                <th><input type="checkbox" className="installed_heading_Check_box" onClick={() => { SelectAllCheckboxes.selectAllCheckbox("Installed_buildings_checkboxes", "installed_heading_Check_box"); }} /></th>
                                <th onClick={this.onSort('siteName')}  className="link_cursor">Building Name<span className={this.setArrow('siteName')}></span> </th>
                                <th>Status</th>
                                <th onClick={this.onSort('numberOfPanelsLoaded')}  className="link_cursor">Devices Loaded <span className={this.setArrow('numberOfPanelsLoaded')}></span> </th>
                                </tr>
                                {BuildingsList}
                            </tbody> 
                        </Table>
                        {CountList}
                    </div>
                </div>

            <div className="btns_div">
                     <p className="bold_sub_text">Selected&nbsp;Buildings</p>
                     <Button className="btn-black btn-md bldng_intllns_btns bldng_successInstalled_btns"    onClick={this.delete_Failed_Installations}  > {"Delete from System"}</Button>
                     <Button className="btn-success btn-md bldng_intllns_btns bldng_successInstalled_btns" onClick = {this.SynchronizedDatabase}>{"Synchronize Database"}</Button>
                    </div>
             </div>
              
             <Modal isOpen={this.state.Deletemodal} deletemodal={this.Deletemodal} className={classnames({ classnames: this.props.className }, "ModalContainer short_modal")} >
                    <DeleteConfirmation parentToChildData={["Delete Building Confirmation", "Important! You are about to delete this building from the Tracer Ensemble system. Do you want to continue? Click Yes to delete the building or No to keep the building in the system."]} Delete={this.Delete} />
            </Modal>

            <Modal isOpen={this.state.showmodal}  style={{width:'400px',height:'80px'}}>
                <p>{this.state.message}</p>
                <Button className="btn-black btn-md ChangeLimits_Applybtn" onClick={this.hidemodal} style={{width:"20%", marginLeft:"125px"}}>ok</Button>
            </Modal>
            </div>
        );
    }
}




const mapStateToProps = state => {
    return {
        Discovered_buildings_list_response: state.InstallationsRootReducer.BuildingsDiscovered,
        getResponse: state.InstallationsRootReducer.Synchronizedata,
        getLabels: state.CulturalLabelsRootReducer.SystemAdmin_LabelsBasedOnPreference
    };
};

const mapDispatchToProps = dispatch => {
    return {
        SynchronizedDatabase:(data) => dispatch(SynchronizedDatabase(data)),
        GetBuildingsDiscovered: () => dispatch(GetBuildingsDiscovered()),
        DeleteInstalledBuildings: (data) => dispatch(DeleteInstalledBuildings(data)),
        getAllResources: () => dispatch(getAllResources())
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(InstalledBuildings);
